import { Controller } from "@hotwired/stimulus"

// 비밀번호 확인 검증 컨트롤러
// 포커스를 잃을 때 비밀번호 필드와 일치 여부를 검증하고 결과 표시
// registration-form 컨트롤러에 상태 변경 알림
export default class extends Controller {
  static targets = ["input", "matchMessage", "mismatchMessage"]
  static values = { passwordField: String }
  static outlets = ["registration-form"]

  connect() {
    this.hideMessages()
    this._isMatch = false
  }

  // 외부에서 비밀번호 일치 상태 확인용
  get isMatch() {
    return this._isMatch
  }

  // registration-form 컨트롤러에 상태 변경 알림
  notifyFormController() {
    if (this.hasRegistrationFormOutlet) {
      this.registrationFormOutlet.passwordConfirmChanged()
    }
  }

  validate() {
    const confirmValue = this.inputTarget.value
    const passwordField = document.getElementById(this.passwordFieldValue)
    const passwordValue = passwordField ? passwordField.value : ""

    // 값이 없으면 메시지 숨김
    if (!confirmValue) {
      this._isMatch = false
      this.hideMessages()
      this.resetInputStyle()
      // 앞서 불일치로 걸어 둔 검증을 푼다 — 남겨 두면 필드를 비워도 제출이 막힌다.
      this.setValidity("")
      this.notifyFormController()
      return
    }

    // 비밀번호가 입력되지 않은 경우
    if (!passwordValue) {
      this._isMatch = false
      this.hideMessages()
      this.resetInputStyle()
      this.setValidity("")
      this.notifyFormController()
      return
    }

    // 일치 여부 확인
    if (confirmValue === passwordValue) {
      this._isMatch = true
      this.showMatch()
    } else {
      this._isMatch = false
      this.showMismatch()
    }

    this.notifyFormController()
  }

  hideMessages() {
    this.matchMessageTarget.classList.add("hidden")
    this.mismatchMessageTarget.classList.add("hidden")
  }

  resetInputStyle() {
    this.inputTarget.classList.remove("border-success-500", "border-danger-500")
  }

  // 브라우저 기본 검증에 불일치를 알린다.
  //
  // 이 컨트롤러는 원래 메시지와 테두리 색만 바꿨을 뿐 제출을 막지 않았다. 가입 화면은
  // registration-form 이 제출 시점에 따로 검사하지만, 비밀번호 재설정 화면에는 그런
  // 컨트롤러가 없어 "일치하지 않습니다" 를 띄운 채로 전송이 나갔다.
  //
  // setCustomValidity 에 빈 문자열이 아닌 값이 들어 있으면 브라우저가 form submit 자체를
  // 막고 말풍선을 띄운다. 컨트롤러가 붙은 모든 화면이 한 번에 덮이고, 새 컨트롤러도
  // 폼별 배선도 필요 없다. (서버 검증은 그대로 최종 방어선이다.)
  setValidity(message) {
    this.inputTarget.setCustomValidity(message)
  }

  showMatch() {
    this.hideMessages()
    this.matchMessageTarget.classList.remove("hidden")
    this.inputTarget.classList.remove("border-danger-500")
    this.inputTarget.classList.add("border-success-500")
    this.setValidity("")
  }

  showMismatch() {
    this.hideMessages()
    this.mismatchMessageTarget.classList.remove("hidden")
    this.inputTarget.classList.remove("border-success-500")
    this.inputTarget.classList.add("border-danger-500")
    this.setValidity("비밀번호가 일치하지 않습니다")
  }
}
